<template>
  <div class="common-tip-wrap">
    <div class="btnfeedback-box" @click="handleFeedback">
      <img class="icon-message" src="@/assets/icon_message2.png" />
      <span>用户反馈</span>
      <DialogCustomFeedback ref="dialogCustomFeedback"></DialogCustomFeedback>
    </div>
    <template v-if="userInfo&&userInfo.id_public_user_info!=92">
<!--      <el-tooltip
        v-if="userInfo.user_remark_018==1802||userInfo.user_remark_018==1803||userInfo.user_remark_018==1804"
        placement="left"
        :enterable="true"
        popper-class="code-custom-tooltip"
        effect="light"
      >
        <div slot="content" class="code-tooltip-inner">
          <div class="code-tooltip-inner-title">社群二维码</div>
          <div class="code-tooltip-inner-img-wrap">
            <el-image
              class="code-tooltip-inner-img"
              :src="userShopInfo.public_agent_info.agent_remark_008"
              :fit="fit">
            </el-image>
          </div>
        </div>
        <div class="btnfeedback-box border-top-none">
          <img class="icon-message" src="@/assets/icon_code.png" />
          <span>社群二维码</span>
        </div>
      </el-tooltip>-->
      <el-tooltip
        placement="left"
        :enterable="true"
        popper-class="share-custom-tooltip"
        effect="light"
      >
        <div slot="content" class="share-tooltip-inner">
          <div class="share-tooltip-content">一键分享，组建自己的小团队。</div>
          <div class="share-tooltip-btm" @click="handleCopy">复制链接</div>
        </div>
        <div class="btnfeedback-box border-top-none">
          <img class="icon-message" src="@/assets/icon_share.png" />
          <span>分享链接</span>
        </div>
      </el-tooltip>
      <el-tooltip
        placement="left"
        :enterable="true"
        popper-class="code-custom-tooltip"
        effect="light"
      >
        <div slot="content" class="code-tooltip-inner">
          <div class="code-tooltip-inner-title">关注公众号</div>
          <div class="code-tooltip-inner-img-wrap">
            <img class="code-tooltip-inner-img" src="@/assets/about_code.png">
          </div>
        </div>
        <div class="btnfeedback-box border-top-none">
          <img class="icon-message" src="@/assets/icon_code.png" />
          <span>关注公众号</span>
        </div>
      </el-tooltip>
    </template>
  </div>
</template>

<script>
import DialogCustomFeedback from "@/components/dialog/CustomFeedback";
export default {
  name: "ButtonFeedback",
  components:{
      DialogCustomFeedback
  },
  data() {
    return {
      fit:'cover'
    };
  },
  computed:{
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
    userShopInfo: function () {
      let _this = this;
      let userShopInfo = _this.$store.state.userShopInfo;
      console.log(userShopInfo)
      return userShopInfo;
    },
  },
  methods: {
    handleFeedback:function(){
      let _this=this;
      _this.$refs.dialogCustomFeedback.showDialog=true;
    },
    handleCopy(){
      let oInput=document.createElement('input');
      oInput.value='http://www.duzikai.com/#/RegisterUpline?upline_id='+this.userInfo.id_public_user_info;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      // 执行浏览器复制命令
      /// 复制命令会将当前选中的内容复制到剪切板中
      /// 如这里构建的 Input标签
      document.execCommand("Copy");
      this.$message.success("复制成功");
      ///复制成功后再将构造的标签 移除
      oInput.remove();
      this.isDownLoadding=false;
    }
  }
}
</script>

<style lang="less">
.common-tip-wrap{
  position: fixed;
  top: 600px;
  right: 0;
  .btnfeedback-box {
    width: 74px;
    height: 74px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    opacity: 0.9;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 19px;
    box-sizing: border-box;
    cursor: pointer;
    &.border-top-none{
      border-top: none;
    }
    z-index:1;
    .icon-message {
      margin-top:7px;
      position: relative;
      width: 36px;
      height: 36px;
    }
  }
}
.el-tooltip__popper.code-custom-tooltip{
  box-shadow: 0px 3px 38px 0px rgba(58,58,58,0.1);
  border-radius: 4px;
  &.is-light{
    border:none;
  }
  .popper__arrow{
    border:none;
  }
}
.code-tooltip-inner{
  padding:16px 18px 18px 18px;
  width:204px;
  height:230px;
  background:#FFF;
  .code-tooltip-inner-title{
    margin-bottom:12px;
    font-size: 16px;
    font-weight: bolder;
    color: #222;
    text-align:center;
  }
  .code-tooltip-inner-img-wrap{
    width:168px;
    height:168px;
    padding:14px;
    background-size:100%;
    background-position:center;
    background-repeat:no-repeat;
    background-image:url(~@/assets/bg-qrcode.png);
    .code-tooltip-inner-img{
      width:100%;
      height:100%;
    }
  }
}
.el-tooltip__popper.share-custom-tooltip{
  box-shadow: 0px 3px 38px 0px rgba(58,58,58,0.1);
  border-radius: 4px;
  &.is-light{
    border:none;
  }
  .popper__arrow{
    border:none;
  }
}
.share-tooltip-inner{
  padding:24px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  .share-tooltip-content{
    font-size:14px;
    font-weight:400;
    color:#222;
  }
  .share-tooltip-btm{
    margin-top:20px;
    width:82px;
    height:30px;
    border-radius:4px;
    border:1px solid #EC4040;
    font-size:14px;
    font-weight:500;
    color:#EC4040;
    line-height:30px;
    text-align:center;
    cursor:pointer;
    &:hover {
      border:1px solid #EF6060;
      color:#EF6060;
    }
  }
}
</style>
